//Library
import axios from "axios";
import { Base64 } from 'js-base64';
import Cookies from "universal-cookie";

//component
import ChkApiResponse from '../components/ApiResponse/ApiResponse';
//config
import config from '../config';

export const SETCOMBINLIST = "SETCOMBINLIST";
export const SETTOKEN = "SETTOKEN";
export const SETNAME = "SETNAME";
export const PURCHASEINIT = "PURCHASEINIT";
export const STEPCOMPLETE = "STEPCOMPLETE";
export const SETSELECTDATA = "SETSELECTDATA";
export const GETPDF = "GETPDF";
export const LOGOUT = "LOGOUT";
export const SETERRORMSG = "SETERRORMSG";
export const EXPERTINDO = "EXPERTINDO";
export const FAQLOAD = "FAQLOAD";
export const FOOTER = "FOOTER";
export const CLEAN = "CLEAN";
export const GETTSRINFO = "GETTSRINFO";
export const SETTSRFUND = "SETTSRFUND";
export const SAVECOMBINITEM = "SAVECOMBINITEM";
export const CLEANCOMBINITEM = "CLEANCOMBINITEM";
/**************************************************************
 *                      登入前 API
 **************************************************************/

//取得投資組合
export const getCombinList = () => {
    return (dispatch, getState) => {
        axios.get(config.path + "/api/GD_ALT_RSP/CombinList", { headers: { 'Content-Type': 'application/json; charset=utf-8' } })
            .then(response => {
                if (ChkApiResponse(response, getState)) {
                    dispatch(getCombinListSuccess(response.data))
                }
            })
            .catch(error => {

            })
    }
}
//取的錯誤碼及錯誤訊息
export const getErrorMsg = () => {
    return (dispatch, getState) => {
        axios.get(config.path + "/api/Values/Initial", "", { headers: { 'Content-Type': 'application/json; charset=utf-8' } })
            .then(response => {
                localStorage.setItem("ErrorMsg", JSON.stringify({ ...response.data.data.apiRtnCodeList, date: new Date().yyyymmdd() }));
                dispatch(getErrorMsgSuccess(response.data));
            })
            .catch(error => { })
    }
}
//儲存錯誤碼及錯誤訊息
export const setErrorMsgByCookie = (value) => {
    return {
        type: SETERRORMSG,
        payload: value
    }
}
//取得專家建議List
export const getExpertInfo = () => {
    return (dispatch, getState) => {
        let startC = getState().anueInfoState.expertInfo === undefined ? 0 : getState().anueInfoState.expertInfo.length;
        // let data = { Category: "", Tag: Base64.encode("退休規劃"), startCount: (startC + 1).toString(), endCount: (Number(startC) + 100).toString(), FilterStatus: true };
        let data =
        {
            BFNo: "",
            SearchType: 1,
            IndexOfSmallGroups: [],
            IndexOfTags: [],
            KeyWord: "",
            PageSize: 5,
            PageIndex: 1,
            SortType: 1,
            IsGetAllData: true,
            EntryQueryNames:["好日子"],
            PathQueryType:3,
            IsGetPageData:false
        };
        // axios.post(config.path + "/api/News/WPNews", JSON.stringify(data), { headers: { 'Content-Type': 'application/json; charset=utf-8' } })
        axios.post( config.CMSpath + '/InvestmentArticle/GetIndexSearchArticlList', JSON.stringify(data), { headers: { 'Content-Type': 'application/json; charset=utf-8' } })
            .then(response => {
                // console.log(response);
                // if (ChkApiResponse(response, getState)) {
                    let rtn = response.data.Entries.SearchedArticles.map(m =>({
                        permalink:config.domainPath + '/investment-article/' + m.CEventNo,
                        title:m.CName,
                        excerpt:m.CDescription,
                        // imgUrl:config.domainPath + m.CListImage_m
                        imgUrl:(m.CListImage_m.indexOf("http") !== -1 ? '' : config.domainPath ) + m.CListImage_m
                    }));
                    // console.log(rtn);
                    // dispatch(getExpertInfoSuccess(response.data));
                    dispatch(getExpertInfoSuccess(rtn));
                // }
            })
            .catch(error => { })
    }
}
//取得FAQ
export const getFAQ = () => {
    let data = {CCategoryMainId : 14, CCategorySubId: 0, IsAccessible: false};
    return (dispatch, getState) => {
        axios.post(config.domainPath + "/cmsapi/Article/GetFaqList", data, { headers: { 'Content-Type': 'application/json; charset=utf-8' } })
            .then(response => {
                dispatch(getFAQSuccess(response.data.Entries.FaqList));
            })
            .catch(error => { })
    }
}
//取得Footer
export const getFooter = () => {
    let data = {CId: 1};
    return (dispatch, getState) => {
        axios.post(config.domainPath + "/cmsapi/Home/GetFooterContent", data, { headers: { 'Content-Type': 'application/json; charset=utf-8' } })
            .then(response => {
                dispatch(getFooterSuccess(response.data.Entries[0].CContent));
            })
            .catch(error => { })
    }
}

//首頁投組申購 暫存申購的投組資料
export const saveCombinItem = (data) => {
    return {
        type: SAVECOMBINITEM,
        payload: data
    }
}
//暫存資料刪除
export const cleanCombinItem = (data) => {
    return {
        type: CLEANCOMBINITEM,
    }
}

function getErrorMsgSuccess(value) {
    return {
        type: SETERRORMSG,
        payload: value.data.apiRtnCodeList
    }
}
function getCombinListSuccess(data) {
    return {
        type: SETCOMBINLIST,
        payload: data.data.combinList
    }
}
function getExpertInfoSuccess(value) {
    return {
        type: EXPERTINDO,
        // payload: value.data.wpList
        payload:value
    }
}
function getFAQSuccess(value) {
    return {
        type: FAQLOAD,
        payload: value
    }
}

function getFooterSuccess(value) {
    return {
        type: FOOTER,
        payload: value
    }
}
/**************************************************************
 *                      登入動作 API
 **************************************************************/
//檢查 AccessToken
export const ChkAccessTkn = (token, back) => {
    return (dispatch, getState) => {
        axios.get(config.path + "/api/login/anuefund/ChkAccessTkn", { headers: { 'Content-Type': 'application/json; charset=utf-8', 'Authorization': 'Bearer ' + token.accessToken } })
            .then(response => {
                console.log(response);
                dispatch(setToken(token));
                dispatch(setName(response));
                back(true);
            })
            .catch(error => {
                //沒登入不處理
                back(false);
            })
            
    }
    
}

//登入
export const loginApi = (data, back) => {
    return (dispatch, getState) => {
        axios.post(config.path + "/api/Login/anuefundV2", data, { headers: { 'Content-Type': 'application/json; charset=utf-8' } })
            .then(response => {
                if (ChkApiResponse(response, getState)) {
                    let cookie = new Cookies();
                    //alert(response.data.data.refreshToken);
                    cookie.set('anueFundToken', JSON.stringify({accessToken: response.data.data.accessToken ,refreshToken: response.data.data.refreshToken }), { path: '/', secure: false, sameSite : "lax"});
                    
                    //寫名字 戶號
                    cookie.set('CustName2', response.data.data.custName, { path: '/',secure: false,sameSite :"lax"});

                    let markname = response.data.data.custName;
                    if(markname.length < 4){
                        markname = markname.substring(0,1) + "○"+ markname.substring(2);
                    } else {
                        markname= markname.substring(0,2) + "○" + markname.substring(3);
                    }
                    try{
                        cookie.set('CustName', markname, { path: '/',secure: false,sameSite :"lax"});
                    } catch {
                        cookie.set('CustName', response.data.data.custName.substring(0,1) + "OO", { path: '/',secure: false,sameSite :"lax"});
                    }
                    
                    cookie.set('acount', response.data.data.bNo, { path: '/',secure: false,sameSite :"lax"});
                    
                    var newDateObj = new Date(new Date().getTime() + (10 * 60 * 1000));
                    cookie.set("autoLogoutTime", newDateObj.toString(), {secure: false, path:"/", sameSite: "lax"});
                    cookie.remove("anueFakeLogin", { path: '/' });
                    
                    dispatch(loginApiSuccess(response.data));
                    back(response.data);
                }
            })
            .catch(error => {

            })
    }
    
}
//取得是否登入中
export const setLoginByRefTkn = (value) => dispatch => {
    dispatch({
        type: SETTOKEN,
        payload: value
    })
    return Promise.resolve();
}

//取得是否登入中
export const setLoginByCookie = (value) => dispatch => {
    dispatch({
        type: SETTOKEN,
        payload: value
    })
}

//登出
export const logout = () => dispatch  => {
   
    let cookie = new Cookies();
    cookie.remove('anueFundToken', { path: '/' });
    cookie.remove('CustName', { path: '/' });
    cookie.remove('CustName2', { path: '/' });
    cookie.remove('acount', { path: '/' });
    cookie.remove("autoLogoutTime",{ path: '/' });
    cookie.remove("anueFakeLogin", { path: '/' });
    dispatch(logoutSuccess());

    //return (dispatch, getState) => {
    //    axios.get(config.path + "/api/Login/Logout/" + getState().anueInfoState.refreshToken, { headers: { 'Content-Type': 'application/json; charset=utf-8' } })
    //        .then(response => {
    //            logoutSuccess();
    //        })
    //        .catch(error => {
    //
    //        })
    //}
}

export const cleanRedux = () => {
    return {
        type: CLEAN
    }
}

function loginApiSuccess(data) {
    return {
        type: SETTOKEN,
        payload: data.data
    }
}
function logoutSuccess() {
    return {
        type: LOGOUT,
    }
}

function setToken(data) {
    return {
        type: SETTOKEN,
        payload: data
    }
}

function setName(data) {
    return {
        type: SETNAME,
        payload: data.data
    }
}
/**************************************************************
 *                      登入後 API
 **************************************************************/

//取得登入後資訊
export const purchaseInit = (back) => {
    return (dispatch, getState) => {
        axios.get(config.path + "/api/GD_ALT_RSP/Init", { headers: { 'Content-Type': 'application/json; charset=utf-8', 'Authorization': 'Bearer ' + getState().anueInfoState.accessToken } })
            .then(response => {
                if (ChkApiResponse(response, getState)) {
                    dispatch(purchaseInitSuccess(response.data));
                    back(response.data);
                }
            })
            .catch(error => {

            })
    }
}
//沿用密碼更新
export const updatePwd = (back) => {
    return (dispatch, getState) => {
        axios.get(config.path + "/api/PWD/anuefund/UpdatePwdDate", { headers: { 'Content-Type': 'application/json; charset=utf-8', 'Authorization': 'Bearer ' + getState().anueInfoState.accessToken } })
        .then(response => {
            if (ChkApiResponse(response, getState)) {
                back(response.data);
            }
        })
        .catch(error => {

        })
    }
}
//取得PDF
export const getPDF = (data, back) => {
    return (dispatch, getState) => {
        axios.post(config.path + "/api/GD_ALT_RSP/PDF", JSON.stringify(data), { headers: { 'Content-Type': 'application/json; charset=utf-8', 'Authorization': 'Bearer ' + getState().anueInfoState.accessToken } })
            .then(response => {
                if (ChkApiResponse(response, getState)) {
                    dispatch(getPDFSuccess(response.data));
                }
            })
            .catch(error => {

            })
    }
}

//檢核Kyc
export const checkKyc = (data, back) => {
    return (dispatch, getState) => {
        axios.post(config.path + "/api/GD_ALT_RSP/KycCheck", JSON.stringify(data), { headers: { 'Content-Type': 'application/json; charset=utf-8', 'Authorization': 'Bearer ' + getState().anueInfoState.accessToken } })
            .then(response => {
                if (ChkApiResponse(response, getState)) {
                    back(response.data);
                }
            })
            .catch(error => {

            })
    }
}

//取得手續費跟優惠
export const getCalFeeRate = (data, back) => {
    return (dispatch, getState) => {
        axios.post(config.path + "/api/GD_ALT_RSP/CalFeeRate", JSON.stringify(data), { headers: { 'Content-Type': 'application/json; charset=utf-8', 'Authorization': 'Bearer ' + getState().anueInfoState.accessToken } })
            .then(response => {
                if (ChkApiResponse(response, getState)) {
                    back(response.data);
                }
            })
            .catch(error => {

            })
    }
}
//申購完成
export const stepComplete = (data, back) => {
    return (dispatch, getState) => {
        let tradeNo = getState().anueInfoState.tradeNo;
        axios.post(config.path + "/api/GD_ALT_RSP/Complete", JSON.stringify({ ...data, tradeNo }), { headers: { 'Content-Type': 'application/json; charset=utf-8', 'Authorization': 'Bearer ' + getState().anueInfoState.accessToken } })
            .then(response => {
                if (ChkApiResponse(response, getState)) {
                    dispatch(stepCompleteSuccess(response.data));
                    back(response.data);
                }
            })
            .catch(error => {

            })
    }
}
//儲存選擇的資訊
export const setSelectData = (data) => {
    return {
        type: SETSELECTDATA,
        payload: data
    }
}
//取得轉申購資訊
export const getTsrInfo = (fundid, sid) => {
    return (dispatch, getState) => {
        axios.get(config.path + "/api/GD_ALT_RSP/TsrInit/" + fundid + "/" + sid, { headers: { 'Content-Type': 'application/json; charset=utf-8', 'Authorization': 'Bearer ' + getState().anueInfoState.accessToken } })
            .then(response => {
                if (ChkApiResponse(response, getState)) {
                    dispatch(getTsrInfoSuccess(response.data, sid));
                }
            })
            .catch(error => {

            })
    }
}
//選擇要轉申購的基金
export const setTsrFund = (fundData) => {
    return {
        type: SETTSRFUND,
        payload: fundData
    }
}
//轉申購確認
export const stepTsrComplete = (data, back) => {
    return (dispatch, getState) => {
        axios.post(config.path + "/api/GD_ALT_RSP/TsrComplete", JSON.stringify(data), { headers: { 'Content-Type': 'application/json; charset=utf-8', 'Authorization': 'Bearer ' + getState().anueInfoState.accessToken } })
            .then(response => {
                if (ChkApiResponse(response, getState)) {
                    back();
                }
            })
            .catch(error => {

            })
    }
}
function purchaseInitSuccess(data) {
    return {
        type: PURCHASEINIT,
        payload: data.data
    }
}
function getPDFSuccess(data) {
    return {
        type: GETPDF,
        payload: data.data
    }
}
function stepCompleteSuccess(data) {
    return {
        type: STEPCOMPLETE,
        payload: data.data.data
    }
}
function getTsrInfoSuccess(data, sid) {
    return {
        type: GETTSRINFO,
        payload: { ...data.data, sid: sid }
    }
}
